import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { FontSizes, FontWeights } from '../../../../types/common/types';

export const templateAccountRoleAndPrivileges = document.createElement('template');

templateAccountRoleAndPrivileges.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div id='role-privileges-section'>
    <gz-title fontSize='18' class='subsection-title' fontWeight='${FontWeights.MEDIUM}' id='role-privileges-section-title'></gz-title>

    <gz-form-field id='role' label='' required>
      <gz-dropdown gz-form-input id='role-dropdown' labelWidth='240'></gz-dropdown>
      <gz-input-error></gz-input-error>
    </gz-form-field>

    <gz-info-box severity='error' id='no-rights-selected-error' class='hidden'></gz-info-box>

    <gz-form-field id='at-least-one-right-checked' class='hidden' required>
      <gz-input gz-form-input class='input-content' inputwidth='240'></gz-input>
      <gz-input-error></gz-input-error>
    </gz-form-field>

    <label id="rights-subtitle"></label>
    <div id='role-rights'>
      <gz-form-field cloud onprem disabled id='manageInventory' class='role-right'>
        <gz-checkbox gz-form-input id='manage-inventory-checkbox' class='role-right-checkbox'></gz-checkbox>
        <gz-text fontSize='${FontSizes.PARAGRAPH_12}' id='manage-inventory-description' class='helper-text role-right-description'></gz-text>
      </gz-form-field>

      <gz-form-field cloud onprem disabled id='manageReports' class='role-right subfield-right'>
        <gz-checkbox gz-form-input id='manage-reports-checkbox' class='role-right-checkbox'></gz-checkbox>
        <gz-text fontSize='${FontSizes.PARAGRAPH_12}' id='manage-reports-description' class='helper-text role-right-description'></gz-text>
      </gz-form-field>

      <gz-form-field cloud disabled id='manageRemoteShell' class='role-right subfield-right'>
        <gz-checkbox gz-form-input id='advanced-investigation-checkbox' class='role-right-checkbox'></gz-checkbox>
        <gz-text fontSize='${FontSizes.PARAGRAPH_12}' id='advanced-investigation-description' class='helper-text role-right-description'></gz-text>
      </gz-form-field>

      <gz-form-field cloud onprem disabled id='managePolicies' class='role-right'>
        <gz-checkbox gz-form-input id='manage-policies-checkbox' class='role-right-checkbox'></gz-checkbox>
        <gz-text fontSize='${FontSizes.PARAGRAPH_12}' id='manage-policies-description' class='helper-text role-right-description'></gz-text>
      </gz-form-field>

      <gz-form-field cloud onprem disabled id='managePoliciesRead' class='role-right subfield-right'>
        <gz-checkbox gz-form-input id='manage-policies-read-checkbox' class='role-right-checkbox'></gz-checkbox>
        <gz-text fontSize='${FontSizes.PARAGRAPH_12}' id='manage-policies-read-description' class='helper-text role-right-description'></gz-text>
      </gz-form-field>

      <gz-form-field cloud onprem disabled id='managePoliciesWrite' class='role-right subfield-right'>
        <gz-checkbox gz-form-input id='manage-policies-write-checkbox' class='role-right-checkbox'></gz-checkbox>
        <gz-text fontSize='${FontSizes.PARAGRAPH_12}' id='manage-policies-write-description' class='helper-text role-right-description'></gz-text>
      </gz-form-field>

      <gz-form-field cloud onprem disabled id='manageUsers' class='role-right'>
        <gz-checkbox gz-form-input id='manage-users-checkbox' class='role-right-checkbox'></gz-checkbox>
        <gz-text fontSize='${FontSizes.PARAGRAPH_12}' id='manage-users-description' class='helper-text role-right-description'></gz-text>
      </gz-form-field>

      <gz-form-field cloud onprem disabled id='companyManager' class='role-right'>
        <gz-checkbox gz-form-input id='manage-company-checkbox' class='role-right-checkbox'></gz-checkbox>
        <gz-text fontSize='${FontSizes.PARAGRAPH_12}' id='manage-company-description' class='helper-text role-right-description'></gz-text>
      </gz-form-field>

      <gz-form-field cloud disabled id='manageCompanies' class='role-right'>
        <gz-checkbox gz-form-input id='manage-companies-checkbox' class='role-right-checkbox'></gz-checkbox>
        <gz-text fontSize='${FontSizes.PARAGRAPH_12}' id='manage-companies-description' class='helper-text role-right-description'></gz-text>
      </gz-form-field>

      <gz-form-field onprem disabled id='managePlatform' class='role-right hidden'>
        <gz-checkbox gz-form-input id='manage-solution-checkbox' class='role-right-checkbox'></gz-checkbox>
        <gz-text fontSize='${FontSizes.PARAGRAPH_12}' id="manage-solution-description" class='helper-text role-right-description'></gz-text>
      </gz-form-field>
    </div>

  </div>`;
